import { defineMessages } from 'react-intl';
import { INBOX_CTA_TITLES } from './inbox-cta-data';

export const intlGuestStatusTexts = defineMessages({
  expiresIn: {
    id: 'inbox.guest_status.expires_in',
    defaultMessage: 'Expires in {expires}'
  },
  inquiredTitle: {
    id: 'inbox.guest_status.inquiry_with',
    defaultMessage: 'Inquiry with {name}'
  },
  inquiredHeading: {
    id: 'inbox.guest_status.you_inquired',
    defaultMessage: 'Inquiry sent to {name}'
  },
  inquiredMobileHeading: {
    id: 'inbox.guest_status.inquired_inquiry',
    defaultMessage: 'Inquiry'
  },
  inquiredContent: {
    id: 'inbox.guest_status.inquiry_content',
    defaultMessage: 'Let {name} know about your specific space needs. This space is not confirmed yet and may be booked by other guests. Use the request to book button to reserve your date.'
  },
  requestedTitle: {
    id: 'inbox.guest_status.requested_title',
    defaultMessage: 'Request with {name}'
  },
  requestedHeading: {
    id: 'inbox.guest_status.requested_heading',
    defaultMessage: 'You requested to book {name}\'s space'
  },
  requestedMobileHeading: {
    id: 'inbox.guest_status.requested_request',
    defaultMessage: 'Request'
  },
  requestedContent: {
    id: 'inbox.guest_status.requested_content',
    defaultMessage: 'Your host has 2 business days to respond (but most respond much faster than that).'
  },
  acceptedTitle: {
    id: 'inbox.guest_status.accepted_title',
    defaultMessage: 'Booking with {name}'
  },
  acceptedHeading: {
    id: 'inbox.guest_status.accepted_heading',
    defaultMessage: 'Your booking is confirmed'
  },
  acceptedMobileHeading: {
    id: 'inbox.guest_status.accepted_accepted',
    defaultMessage: 'Accepted'
  },
  expiredTitle: {
    id: 'inbox.guest_status.expired_title',
    defaultMessage: 'Expired Request with {name}'
  },
  expiredHeading: {
    id: 'inbox.guest_status.expired_heading',
    defaultMessage: 'Your booking request has expired'
  },
  expiredMobileHeading: {
    id: 'inbox.guest_status.expired',
    defaultMessage: 'Expired'
  },
  expiredContent: {
    id: 'inbox.guest_status.expired_content',
    defaultMessage: 'It\'s rare, but sometimes our hosts are unable to respond quickly enough. You can adjust and resend this booking request, or look for other spaces. Your credit card has not been charged.'
  },
  declinedTitle: {
    id: 'inbox.guest_status.declined_title',
    defaultMessage: 'Declined Request with {name}'
  },
  declinedHeading: {
    id: 'inbox.guest_status.declined_heading',
    defaultMessage: '{name} declined your booking request'
  },
  declinedMobileHeading: {
    id: 'inbox.guest_status.declined',
    defaultMessage: 'Declined'
  },
  declinedContent: {
    id: 'inbox.guest_status.declined_content',
    defaultMessage: 'It looks like this didn\'t work out. You can message the host and continue the conversation, adjust and resend your booking request, or look for other spaces. Your credit card has not been charged.'
  },
  executedTitle: {
    id: 'inbox.guest_status.executed_title',
    defaultMessage: 'Booking with {name}'
  },
  executedHeading: {
    id: 'inbox.guest_status.executed_heading',
    defaultMessage: 'Review your experience at {name}\'s space'
  },
  executedMobileHeading: {
    id: 'inbox.guest_status.executed_mobile_heading',
    defaultMessage: 'Review Needed'
  },
  executedContent: {
    id: 'inbox.guest_status.executed_content',
    defaultMessage: 'Your feedback is extremely valuable. Please take a moment to review your experience at {name}\'s space. If you have any private feedback you can share it directly with the Peerspace Support team.'
  },
  completedTitle: {
    id: 'inbox.guest_status.completed_title',
    defaultMessage: 'Booking with {name}'
  },
  completedHeading: {
    id: 'inbox.guest_status.completed_heading',
    defaultMessage: 'Your booking at {name}\'s space is complete'
  },
  completedMobileHeading: {
    id: 'inbox.guest_status.completed',
    defaultMessage: 'Completed'
  },
  withdrawnTitle: {
    id: 'inbox.guest_status.withdrawn_title',
    defaultMessage: 'Withdrawn Request with {name}'
  },
  withdrawnHeading: {
    id: 'inbox.guest_status.withdrawn_heading',
    defaultMessage: 'You withdrew your booking request'
  },
  withdrawnMobileHeading: {
    id: 'inbox.guest_status.withdrawn',
    defaultMessage: 'Withdrawn'
  },
  withdrawnContent: {
    id: 'inbox.guest_status.withdrawn_content',
    defaultMessage: 'It looks like this didn\'t work out. You can adjust and resend your booking request, or look for other spaces. Your credit card has not been charged.'
  },
  underReviewTitle: {
    id: 'inbox.guest_status.under_review_title',
    defaultMessage: 'Booking with {name}'
  },
  underReviewHeading: {
    id: 'inbox.guest_status.under_review_heading',
    defaultMessage: 'You requested to cancel your booking'
  },
  underReviewMobileHeading: {
    id: 'inbox.guest_status.under_review_mobile_heading',
    defaultMessage: 'Cancel Pending'
  },
  underReviewContent: {
    id: 'inbox.guest_status.under_review_content',
    defaultMessage: 'Your cancellation request is being processed and our Customer Experience team will be in touch as soon as they are able. At this time we are overwhelmed with requests due to COVID-19 and are prioritizing processing cancellations by booking start date. Thank you for your patience during this difficult time.'
  },
  underReviewHostTitle: {
    id: 'inbox.guest_status.under_review_host_title',
    defaultMessage: 'Booking with {name}'
  },
  underReviewHostHeading: {
    id: 'inbox.guest_status.under_review_host_heading',
    defaultMessage: 'Your host requested to cancel this booking'
  },
  underReviewHostMobileHeading: {
    id: 'inbox.guest_status.under_review_host_mobile_heading',
    defaultMessage: 'Cancel Pending'
  },
  underReviewHostContent_1: {
    id: 'inbox.guest_status.under_review_host_content_1',
    defaultMessage: 'Your host has requested to cancel this booking and Peerspace support will be in touch as soon as we can. At this time we are overwhelmed with requests due to COVID-19 and are prioritizing processing cancellations by booking start date. To request to reschedule this booking, please'
  },
  underReviewHostContent_2: {
    id: 'inbox.guest_status.under_review_host_content_2',
    defaultMessage: 'contact our Customer Experience team'
  },
  underReviewAdminTitle: {
    id: 'inbox.guest_status.under_review_admin_title',
    defaultMessage: 'Booking with {name}'
  },
  underReviewAdminHeading: {
    id: 'inbox.guest_status.under_review_admin_heading',
    defaultMessage: 'This booking is being cancelled'
  },
  underReviewAdminMobileHeading: {
    id: 'inbox.guest_status.under_review_admin_mobile_heading',
    defaultMessage: 'Cancel Pending'
  },
  underReviewAdminContent_1: {
    id: 'inbox.guest_status.under_review_admin_mobile_heading_1',
    defaultMessage: 'For the safety of our community and to prepare for government mandates, we will be cancelling this booking on your behalf. You will be issued Peerspace Credit for the full booking total, which can be used on any future date. If you have arranged to keep the booking with your host, please'
  },
  underReviewAdminContent_2: {
    id: 'inbox.guest_status.under_review_admin_mobile_heading_2',
    defaultMessage: 'request to keep your booking active'
  },
  underReviewAdminContent_3: {
    id: 'inbox.guest_status.under_review_admin_mobile_heading_3',
    defaultMessage: 'as soon as possible. For any other concerns, please'
  },
  underReviewAdminContent_4: {
    id: 'inbox.guest_status.under_review_admin_mobile_heading_4',
    defaultMessage: 'contact our Customer Experience team'
  },
  underReviewAdminContent_5: {
    id: 'inbox.guest_status.under_review_admin_mobile_heading_5',
    defaultMessage: 'and we will get back to you as soon as we can. At this time we are overwhelmed with requests due to COVID-19 and appreciate your patience.'
  },
  noAuthTitle: {
    id: 'inbox.guest_status.no_auth_title',
    defaultMessage: 'Request with {name}'
  },
  noAuthHeading: {
    id: 'inbox.guest_status.no_auth_heading',
    defaultMessage: 'Your credit card was declined'
  },
  noAuthMobileHeading: {
    id: 'inbox.guest_status.no_auth_mobile_heading',
    defaultMessage: 'Fix Credit Card'
  },
  unableToProcessTitle: {
    id: 'inbox.guest_status.unable_to_process_title',
    defaultMessage: 'Request with {name}'
  },
  unableToProcessHeading: {
    id: 'inbox.guest_status.unable_to_process_heading',
    defaultMessage: 'Unable to process booking'
  },
  unableToProcessMobileHeading: {
    id: 'inbox.guest_status.unable_to_process_mobile_heading',
    defaultMessage: 'Unable to process'
  },
  cancelledHostTitle: {
    id: 'inbox.guest_status.cancelled_host_title',
    defaultMessage: 'Cancelled Booking with {name}'
  },
  cancelledHostHeading: {
    id: 'inbox.guest_status.cancelled_host_heading',
    defaultMessage: '{name} cancelled your booking'
  },
  cancelledHostMobileHeading: {
    id: 'inbox.guest_status.cancelled_host_cancelled',
    defaultMessage: 'Cancelled'
  },
  cancelledHostContentCredit: {
    id: 'inbox.guest_status.cancelled_host_content_credit',
    defaultMessage: 'A Peerspace Credit for {currency}{credits} has been issued to your account which can be used to book any space in the future. You can view your Credit balance from your'
  },
  cancelledHostContentPayments: {
    id: 'inbox.guest_status.cancelled_host_content_payments',
    defaultMessage: 'payments page'
  },
  cancelledHostContentCancellations: {
    id: 'inbox.guest_status.cancelled_host_cancellations',
    defaultMessage: 'Cancellations are rare but do happen occasionally. We have issued you a full refund and will be in touch shortly to help you find a new space.'
  },
  cancelledGuestTitle: {
    id: 'inbox.guest_status.cancelled_guest_title',
    defaultMessage: 'Cancelled Booking with {name}'
  },
  cancelledGuestHeading: {
    id: 'inbox.guest_status.cancelled_guest_heading',
    defaultMessage: 'You cancelled your booking'
  },
  cancelledGuestMobileHeading: {
    id: 'inbox.guest_status.cancelled_guest_cancelled',
    defaultMessage: 'Cancelled'
  },
  cancelledGuestContent_1: {
    id: 'inbox.guest_status.cancelled_guest_content_1',
    defaultMessage: 'It looks like this didn\'t work out. You can contact Peerspace about this booking if you need any additional help, or look for other spaces.'
  },
  cancelledAdminTitle: {
    id: 'inbox.guest_status.cancelled_admin_title',
    defaultMessage: 'Cancelled Booking with {name}'
  },
  cancelledAdminHeading: {
    id: 'inbox.guest_status.cancelled_admin_heading',
    defaultMessage: 'Your booking is cancelled'
  },
  cancelledAdminMobileHeading: {
    id: 'inbox.guest_status.cancelled_admin_cancelled',
    defaultMessage: 'Cancelled'
  },
  cancelledAdminContent: {
    id: 'inbox.guest_status.cancelled_admin_content',
    defaultMessage: 'You can contact Peerspace about this booking if you need any additional help, or look for other spaces.'
  },
  offerSubmittedTitle: {
    id: 'inbox.guest_status.offer_submitted_title',
    defaultMessage: 'Offer Pending with {name}'
  },
  offerSubmittedHeading: {
    id: 'inbox.guest_status.offer_submitted_heading',
    defaultMessage: 'invited you to book'
  },
  offerSubmittedMobileHeading: {
    id: 'inbox.guest_status.offer_submitted_mobile_heading',
    defaultMessage: 'Offer Pending'
  },
  offerSubmittedContent: {
    id: 'inbox.guest_status.offer_submitted_content',
    defaultMessage: 'You have up to 7 days to review the offer before it expires. Until you accept, the offer will not be applied. If you would like changes made to the offer you can message the host below.'
  },
  offerNoCaptureTitle: {
    id: 'inbox.guest_status.offer_no_capture_title',
    defaultMessage: 'Offer Pending with {name}'
  },
  offerNoCaptureHeading: {
    id: 'inbox.guest_status.offer_no_capture_heading',
    defaultMessage: 'Your credit card was declined'
  },
  offerNoCaptureMobileHeading: {
    id: 'inbox.guest_status.offer_no_capture_mobile_heading',
    defaultMessage: 'Fix Credit Card'
  },
  offerNoCaptureContent: {
    id: 'inbox.guest_status.offer_no_capture_content',
    defaultMessage: 'Cards are often declined due to high transaction amounts. Please try a different card or call your bank to clear the charge, then retry the booking. If you need help, please contact support.'
  },
  offerDeclinedTitle: {
    id: 'inbox.guest_status.offer_declined_title',
    defaultMessage: 'Offer Declined with {name}'
  },
  offerDeclinedHeading: {
    id: 'inbox.guest_status.offer_declined_heading',
    defaultMessage: 'You declined {name}\'s offer'
  },
  offerDeclinedMobileHeading: {
    id: 'inbox.guest_status.offer_declined',
    defaultMessage: 'Offer Declined'
  },
  offerDeclinedContent: {
    id: 'inbox.guest_status.offer_declined_content',
    defaultMessage: 'You can ask {name} to send another offer or {ios}. Your credit card has not been charged.'
  },
  offerWithdrawnTitle: {
    id: 'inbox.guest_status.offer_withdrawn_title',
    defaultMessage: 'Offer Withdrawn with {name}'
  },
  offerWithdrawnHeading: {
    id: 'inbox.guest_status.offer_withdrawn_heading',
    defaultMessage: '{name} withdrew their offer'
  },
  offerWithdrawn: {
    id: 'inbox.guest_status.offer_withdrawn',
    defaultMessage: 'Offer Withdrawn'
  },
  offerWithdrawnContent: {
    id: 'inbox.guest_status.offer_withdrawn_content',
    defaultMessage: 'You can ask {name} to send another offer or {ios}. Your credit card has not been charged.'
  },
  offerExpiredTitle: {
    id: 'inbox.guest_status.offer_expired_title',
    defaultMessage: 'Offer Expired with {name}'
  },
  offerExpiredHeading: {
    id: 'inbox.guest_status.offer_expired_heading',
    defaultMessage: '{name}\'s offer has expired'
  },
  offerExpired: {
    id: 'inbox.guest_status.offer_expired',
    defaultMessage: 'Offer Expired'
  },
  offerExpiredContent: {
    id: 'inbox.guest_status.offer_expired_content',
    defaultMessage: 'You did not respond in {hasNoContracts} days, so the offer expired. You can ask {name} to send another offer or {ios}. Your credit card has not been charged.'
  },
  settleBalanceHeading: {
    id: 'inbox.guest_status.settle_balance_heading',
    defaultMessage: 'Your booking has an outstanding balance'
  },
  settleBalanceMobileHeading: {
    id: 'inbox.guest_status.settle_balance_mobile_heading',
    defaultMessage: 'Outstanding balance'
  },
  updateRequestedHostTitle: {
    id: 'inbox.guest_status.update_requested_host_title',
    defaultMessage: 'Update pending with {name}'
  },
  updateRequestedHostHeading: {
    id: 'inbox.guest_status.update_requested_host_heading',
    defaultMessage: '{name} requested to update this booking'
  },
  updateRequestedHostMobileHeading: {
    id: 'inbox.guest_status.update_requested_host_mobile_heading',
    defaultMessage: 'Update Pending'
  },
  updateRequestedHostContent: {
    id: 'inbox.guest_status.update_requested_host_content',
    defaultMessage: 'You have up to 7 days to review the offer before it expires. Until you accept, the offer will not be applied. If you would like changes made to the offer you can message the host below.'
  },
  updateRequestedHostNoAuthTitle: {
    id: 'inbox.guest_status.update_requested_host_no_auth_title',
    defaultMessage: 'Update pending with {name}'
  },
  updateRequestedHostNoAuthHeading: {
    id: 'inbox.guest_status.update_requested_host_no_auth_heading',
    defaultMessage: 'Your credit card was declined'
  },
  updateRequestedHostNoAuthMobileHeading: {
    id: 'inbox.guest_status.update_requested_host_no_auth_mobile_heading',
    defaultMessage: 'Fix Credit Card'
  },
  updateRequestedHostNoAuthContent_1: {
    id: 'inbox.guest_status.update_requested_host_no_auth_content_1',
    defaultMessage: 'Here are some helpful steps to fix this issue:'
  },
  updateRequestedHostNoAuthContent_2: {
    id: 'inbox.guest_status.update_requested_host_no_auth_content_2',
    defaultMessage: 'Try a different card. Note that Peerspace does not accept pre-paid or reloadable cards.'
  },
  updateRequestedHostNoAuthContent_3: {
    id: 'inbox.guest_status.update_requested_host_no_auth_content_3',
    defaultMessage: 'Contact your bank to authorize the charge, then retry the transaction.'
  },
  updateRequestedHostNoAuthContent_4: {
    id: 'inbox.guest_status.update_requested_host_no_auth_content_4',
    defaultMessage: 'If your billing zip code with your bank has changed, re-add your card with the updated zip code.'
  },
  updateRequestedGuestTitle: {
    id: 'inbox.guest_status.update_requested_guest_title',
    defaultMessage: 'Update pending with {name}'
  },
  updateRequestedGuestHeading: {
    id: 'inbox.guest_status.update_requested_guest_heading',
    defaultMessage: 'You requested to update this booking'
  },
  updateRequestedGuestMobileHeading: {
    id: 'inbox.guest_status.update_requested_guest_mobile_heading',
    defaultMessage: 'Update Pending'
  },
  updateRequestedGuestContent: {
    id: 'inbox.guest_status.update_requested_guest_content',
    defaultMessage: '{name} has 2 business days to review the update. If they accept, the changes will take effect. If they decline or you withdraw it, you can request another update.'
  },
  updateRequestedGuestNoAuthTitle: {
    id: 'inbox.guest_status.update_requested_guest_no_auth_title',
    defaultMessage: 'Update pending with {name}'
  },
  updateRequestedGuestNoAuthHeading: {
    id: 'inbox.guest_status.update_requested_guest_no_auth_heading',
    defaultMessage: 'Your credit card was declined'
  },
  updateRequestedGuestNoAuthMobileHeading: {
    id: 'inbox.guest_status.update_requested_guest_no_auth_mobile_heading',
    defaultMessage: 'Fix Credit Card'
  },
  updateRequestedGuestNoAuthContent_1: {
    id: 'inbox.guest_status.update_requested_guest_no_auth_content_1',
    defaultMessage: 'Here are some helpful steps to fix this issue:'
  },
  updateRequestedGuestNoAuthContent_2: {
    id: 'inbox.guest_status.update_requested_guest_no_auth_content_2',
    defaultMessage: 'Try a different card. Note that Peerspace does not accept pre-paid or reloadable cards.'
  },
  updateRequestedGuestNoAuthContent_3: {
    id: 'inbox.guest_status.update_requested_guest_no_auth_content_3',
    defaultMessage: 'Contact your bank to authorize the charge, then retry the transaction.'
  },
  updateRequestedGuestNoAuthContent_4: {
    id: 'inbox.guest_status.update_requested_guest_no_auth_content_4',
    defaultMessage: 'If your billing zip code with your bank has changed, re-add your card with the updated zip code.'
  },
  noStateHeading: {
    id: 'inbox.guest_status.no_state_heading',
    defaultMessage: 'Something went wrong'
  },
  noStateMobileHeading: {
    id: 'inbox.guest_status.no_state_mobile_heading',
    defaultMessage: 'Something went wrong'
  },
  noStateContent: {
    id: 'inbox.guest_status.no_state_content',
    defaultMessage: 'Please contact Peerspace Support.'
  },
  guestClientNeededAuthorizePayment: {
    id: 'inbox.guest_status.authorize_payment',
    defaultMessage: 'Authorize Payment'
  }
});

export const intlHostStatusTexts = defineMessages({
  expiresIn: {
    id: 'inbox.host_status.expires_in',
    defaultMessage: 'Expires in {value} {unit}'
  },
  inquiredTitle: {
    id: 'inbox.host_status.inquired_title',
    defaultMessage: 'Inquiry with {name}'
  },
  inquiredHeading: {
    id: 'inbox.host_status.inquired_heading',
    defaultMessage: '{name} inquired about your space'
  },
  inquiredMobileHeading: {
    id: 'inbox.host_status.inquired',
    defaultMessage: 'Inquiry'
  },
  requestedTitle: {
    id: 'inbox.host_status.requested_title',
    defaultMessage: 'Request with {name}'
  },
  requestedHeading: {
    id: 'inbox.host_status.requested_heading',
    defaultMessage: '{name} requested to book your space'
  },
  requestedMobileHeading: {
    id: 'inbox.host_status.requested',
    defaultMessage: 'Request'
  },
  acceptedTitle: {
    id: 'inbox.host_status.accepted_title',
    defaultMessage: 'Booking with {name}'
  },
  acceptedHeading: {
    id: 'inbox.host_status.accepted_heading',
    defaultMessage: 'Your booking is confirmed'
  },
  acceptedMobileHeading: {
    id: 'inbox.host_status.accepted',
    defaultMessage: 'Accepted'
  },
  expiredTitle: {
    id: 'inbox.host_status.expired_title',
    defaultMessage: 'Expired Request with {name}'
  },
  expiredHeading: {
    id: 'inbox.host_status.expired_heading',
    defaultMessage: '{name}\'s booking request has expired'
  },
  expiredMobileHeading: {
    id: 'inbox.host_status.expired',
    defaultMessage: 'Expired'
  },
  expiredContent: {
    id: 'inbox.host_status.expired_content',
    defaultMessage: 'You did not respond in 2 business days, so the request expired. Letting requests expire may hurt your space\'s visibility. You can ask {name} to send another request or offer them a custom price.'
  },
  declinedTitle: {
    id: 'inbox.host_status.declined_title',
    defaultMessage: 'Declined Request with {name}'
  },
  declinedHeading: {
    id: 'inbox.host_status.declined_heading',
    defaultMessage: 'You declined {name}\'s booking request'
  },
  declinedMobileHeading: {
    id: 'inbox.host_status.declined',
    defaultMessage: 'Declined'
  },
  declinedContent: {
    id: 'inbox.host_status.declined_content',
    defaultMessage: 'It looks like this didn\'t work out. If you need to update the details of the request or adjust the rate, you can offer {name} a custom price.'
  },
  executedReviewTitle: {
    id: 'inbox.host_status.executed_review_title',
    defaultMessage: 'Booking with {name}'
  },
  executedReviewHeading: {
    id: 'inbox.host_status.executed_review_heading',
    defaultMessage: 'Review your experience hosting {name}'
  },
  executedReviewMobileHeading: {
    id: 'inbox.host_status.executed_review_mobile_heading',
    defaultMessage: 'Review Needed'
  },
  executedReviewContent: {
    id: 'inbox.host_status.executed_review_content',
    defaultMessage: 'Your feedback is extremely valuable. Please take a moment to review your experience hosting {name}. If you have any private feedback you can share it directly with the Peerspace Support team.'
  },
  executedCompletedTitle: {
    id: 'inbox.host_status.executed_completed_title',
    defaultMessage: 'Booking with {name}'
  },
  executedCompletedHeading: {
    id: 'inbox.host_status.executed_completed_heading',
    defaultMessage: 'Your booking with {name} is complete'
  },
  executedCompletedMobileHeading: {
    id: 'inbox.host_status.executed_completed',
    defaultMessage: 'Completed'
  },
  withdrawnTitle: {
    id: 'inbox.host_status.withdrawn_title',
    defaultMessage: 'Withdrawn Request with {name}'
  },
  withdrawnHeading: {
    id: 'inbox.host_status.withdrawn_heading',
    defaultMessage: '{name} withdrew their booking request'
  },
  withdrawnMobileHeading: {
    id: 'inbox.host_status.withdrawn',
    defaultMessage: 'Withdrawn'
  },
  withdrawnContent: {
    id: 'inbox.host_status.withdrawn_content',
    defaultMessage: 'It looks like this didn\'t work out. If {name} needs a special rate, you can offer them a custom price.'
  },
  underReviewTitle: {
    id: 'inbox.host_status.under_review_title',
    defaultMessage: 'Booking with {name}'
  },
  underReviewHeading: {
    id: 'inbox.host_status.under_review_heading',
    defaultMessage: '{name}\'s booking is being reviewed for cancellation'
  },
  underReviewMobileHeading: {
    id: 'inbox.host_status.under_review_mobile_heading',
    defaultMessage: 'Cancel Pending'
  },
  underReviewContent: {
    id: 'inbox.host_status.under_review_content',
    defaultMessage: 'The booking is currently under review while the Peerspace team updates the booking details. At this time we are experiencing a higher than average volume due to COVID-19 and are processing cancellations for the upcoming week most urgently. Thank you for your patience.'
  },
  underReviewAdminTitle: {
    id: 'inbox.host_status.under_review_admin_title',
    defaultMessage: 'Booking with {name}'
  },
  underReviewAdminHeading: {
    id: 'inbox.host_status.under_review_admin_heading',
    defaultMessage: 'This booking is being cancelled'
  },
  underReviewAdminMobileHeading: {
    id: 'inbox.host_status.under_review_admin_mobile_heading',
    defaultMessage: 'Cancel Pending'
  },
  underReviewAdminContent_1: {
    id: 'inbox.host_status.under_review_admin_content_1',
    defaultMessage: 'For the safety of our community and to prepare for government mandates, we will be cancelling this booking on your behalf. If you have arranged to keep the booking with your guest, please'
  },
  underReviewAdminContent_2: {
    id: 'inbox.host_status.under_review_admin_content_2',
    defaultMessage: 'request to keep your booking active'
  },
  underReviewAdminContent_3: {
    id: 'inbox.host_status.under_review_admin_content_3',
    defaultMessage: 'as soon as possible. For any other concerns, please'
  },
  underReviewAdminContent_4: {
    id: 'inbox.host_status.under_review_admin_content_4',
    defaultMessage: 'contact our Customer Experience team'
  },
  underReviewAdminContent_5: {
    id: 'inbox.host_status.under_review_admin_content_5',
    defaultMessage: 'and we will get back to you as soon as we can. At this time we are overwhelmed with support requests due to COVID-19 and appreciate your patience.'
  },
  cancelledHostTitle: {
    id: 'inbox.host_status.cancelled_host_title',
    defaultMessage: 'Cancelled Booking with {name}'
  },
  cancelledHostHeading: {
    id: 'inbox.host_status.cancelled_host_heading',
    defaultMessage: 'You cancelled {name}\'s booking'
  },
  cancelledHostMobileHeading: {
    id: 'inbox.host_status.cancelled_host',
    defaultMessage: 'Cancelled'
  },
  cancelledHostContent_1: {
    id: 'inbox.host_status.cancelled_host_content_1',
    defaultMessage: 'The Peerspace team will review this cancellation. Instant Book cancellations are penalty-free under certain circumstances.'
  },
  cancelledHostContent_2: {
    id: 'inbox.host_status.cancelled_host_content_2',
    defaultMessage: 'Learn More'
  },
  cancelledHostContent_3: {
    id: 'inbox.host_status.cancelled_host_content_3',
    defaultMessage: 'Cancellations are very difficult for guests and may result in penalties to your account.'
  },
  cancelledGuestTitle: {
    id: 'inbox.host_status.cancelled_guest_title',
    defaultMessage: 'Cancelled Booking with {name}'
  },
  cancelledGuestHeading: {
    id: 'inbox.host_status.cancelled_guest_heading',
    defaultMessage: '{name} cancelled this booking'
  },
  cancelledGuestMobileHeading: {
    id: 'inbox.host_status.cancelled_guest',
    defaultMessage: 'Cancelled'
  },
  cancelledAdminTitle: {
    id: 'inbox.host_status.cancelled_admin_title',
    defaultMessage: 'Cancelled Booking with {name}'
  },
  cancelledAdminHeading: {
    id: 'inbox.host_status.cancelled_admin_heading',
    defaultMessage: 'This booking is cancelled'
  },
  cancelledAdminMobileHeading: {
    id: 'inbox.host_status.cancelled',
    defaultMessage: 'Cancelled'
  },
  cancelledAdminMobileContent: {
    id: 'inbox.host_status.cancelled',
    defaultMessage: 'Cancelled'
  },
  offerSubmittedTitle: {
    id: 'inbox.host_status.offer_submitted_title',
    defaultMessage: 'Offer Pending with {name}'
  },
  offerSubmittedHeading: {
    id: 'inbox.host_status.offer_submitted_heading',
    defaultMessage: 'You invited {name} to book'
  },
  offerSubmittedMobileHeading: {
    id: 'inbox.host_status.offer_submitted_mobile_heading',
    defaultMessage: 'Offer Pending'
  },
  offerSubmittedContent: {
    id: 'inbox.host_status.offer_submitted_content',
    defaultMessage: '{name} has up to {hasNoContracts} days to review the offer. If they accept, the booking will be confirmed. If they decline or you withdraw it, you can create a new offer.'
  },
  offerNoCaptureTitle: {
    id: 'inbox.host_status.offer_no_capture_title',
    defaultMessage: 'Offer Pending with {name}'
  },
  offerNoCaptureHeading: {
    id: 'inbox.host_status.offer_no_capture_heading',
    defaultMessage: 'You sent {name} an offer'
  },
  offerNoCaptureMobileHeading: {
    id: 'inbox.host_status.offer_no_capture_mobile_heading',
    defaultMessage: 'Offer Pending'
  },
  offerNoCaptureContent: {
    id: 'inbox.host_status.offer_no_capture_content',
    defaultMessage: '{name} has up to 7 days to review the offer. If they accept, the booking will be confirmed. If they decline or you withdraw it, you can create a new offer.'
  },
  offerDeclinedTitle: {
    id: 'inbox.host_status.offer_declined_title',
    defaultMessage: 'Offer Declined with {name}'
  },
  offerDeclinedHeading: {
    id: 'inbox.host_status.offer_declined_heading',
    defaultMessage: '{name} declined your offer'
  },
  offerDeclinedMobileHeading: {
    id: 'inbox.host_status.offer_declined_mobile_heading',
    defaultMessage: 'Offer Declined'
  },
  offerDeclinedContent: {
    id: 'inbox.host_status.offer_declined_content',
    defaultMessage: 'It looks like this didn\'t work out. You can offer {name} a new price or send a message to continue the conversation.'
  },
  offerWithdrawnTitle: {
    id: 'inbox.host_status.offer_withdrawn_title',
    defaultMessage: 'Offer Withdrawn with {name}'
  },
  offerWithdrawnHeading: {
    id: 'inbox.host_status.offer_withdrawn_heading',
    defaultMessage: 'You withdrew your offer'
  },
  offerWithdrawnMobileHeading: {
    id: 'inbox.host_status.offer_withdrawn_mobile_heading',
    defaultMessage: 'Offer Withdrawn'
  },
  offerWithdrawnContent: {
    id: 'inbox.host_status.offer_withdrawn_content',
    defaultMessage: 'It looks like this didn\'t work out. You can send {name} a new offer or send a message to continue the conversation.'
  },
  offerExpiredTitle: {
    id: 'inbox.host_status.offer_expired_title',
    defaultMessage: 'Offer Expired with {name}'
  },
  offerExpiredHeading: {
    id: 'inbox.host_status.offer_expired_heading',
    defaultMessage: 'Your offer has expired'
  },
  offerExpiredMobileHeading: {
    id: 'inbox.host_status.offer_expired_mobile_heading',
    defaultMessage: 'Offer Expired'
  },
  offerExpiredContent: {
    id: 'inbox.host_status.offer_expired_content',
    defaultMessage: '{name} did not respond in {noContracts} days, so the offer expired. You can offer {name} a new price or send a message to continue the conversation.'
  },
  updateRequestedHostTitle: {
    id: 'inbox.host_status.update_requested_host_title',
    defaultMessage: 'Update pending with {name}'
  },
  updateRequestedHostHeading: {
    id: 'inbox.host_status.update_requested_host_heading',
    defaultMessage: 'You requested to update this booking'
  },
  updateRequestedHostMobileHeading: {
    id: 'inbox.host_status.update_requested_host_mobile_heading',
    defaultMessage: 'Update Pending'
  },
  updateRequestedHostContent: {
    id: 'inbox.host_status.update_requested_host_content',
    defaultMessage: '{name} has up to 7 days to review and accept this offer. If they accept, the booking will be confirmed. If they decline or you withdraw, you can create a new offer.'
  },
  updateRequestedGuestTitle: {
    id: 'inbox.host_status.update_requested_guest_title',
    defaultMessage: 'Update Pending with {name}'
  },
  updateRequestedGuestHeading: {
    id: 'inbox.host_status.update_requested_guest_heading',
    defaultMessage: '{name} requested to update this booking'
  },
  updateRequestedGuestMobileHeading: {
    id: 'inbox.host_status.update_requested_guest_mobile_heading',
    defaultMessage: 'Update Pending'
  },
  updateRequestedGuestContent: {
    id: 'inbox.host_status.update_requested_guest_content',
    defaultMessage: 'You have 2 business days to review the update before it expires. Until you accept, the updates will not be applied.'
  },
  noStateHeading: {
    id: 'inbox.host_status.no_state_heading',
    defaultMessage: 'Something went wrong'
  },
  noStateMobileHeading: {
    id: 'inbox.host_status.no_state_mobile_heading',
    defaultMessage: 'Something went wrong'
  },
  noStateMobileContent: {
    id: 'inbox.host_status.no_state_content',
    defaultMessage: 'Please contact Peerspace Support.'
  }
});

export const intlInboxCTAs = defineMessages({
  [INBOX_CTA_TITLES.VIEW_CANCELLATION_DETAILS]: {
    id: 'inbox.inbox_cta.cancellation_details',
    defaultMessage: 'View cancellation details'
  },
  [INBOX_CTA_TITLES.EXPLORE_SPACES]: {
    id: 'inbox.host_status.explore_spaces',
    defaultMessage: 'Explore spaces'
  },
  [INBOX_CTA_TITLES.CONTACT_PEERSPACE_SUPPORT]: {
    id: 'inbox.host_status.contact_support',
    defaultMessage: 'Contact Peerspace support'
  },
  [INBOX_CTA_TITLES.BOOK_NOW]: {
    id: 'inbox.host_status.book_now',
    defaultMessage: 'Book Now'
  },
  [INBOX_CTA_TITLES.START_BOOKING]: {
    id: 'inbox.host_status.start_booking',
    defaultMessage: 'Request to book'
  },
  [INBOX_CTA_TITLES.WITHDRAW_BOOKING]: {
    id: 'inbox.host_status.withdraw_booking',
    defaultMessage: 'Withdraw Booking'
  },
  [INBOX_CTA_TITLES.UPDATE_BOOKING]: {
    id: 'inbox.host_status.update_booking',
    defaultMessage: 'Update booking'
  },
  [INBOX_CTA_TITLES.CANCEL_BOOKING]: {
    id: 'inbox.host_status.cancel_booking',
    defaultMessage: 'Cancel booking'
  },
  [INBOX_CTA_TITLES.BROWSE_ADDONS]: {
    id: 'inbox.host_status.browse_addons',
    defaultMessage: 'Browse add-ons'
  },
  [INBOX_CTA_TITLES.RESEND_BOOKING]: {
    id: 'inbox.host_status.resend_booking',
    defaultMessage: 'Resend Booking Request'
  },
  [INBOX_CTA_TITLES.LEAVE_REVIEW]: {
    id: 'inbox.host_status.leave_review',
    defaultMessage: 'Leave a Review'
  },
  [INBOX_CTA_TITLES.BOOK_AGAIN]: {
    id: 'inbox.host_status.book_again',
    defaultMessage: 'Book Again'
  },
  [INBOX_CTA_TITLES.VIEW_RECEIPT]: {
    id: 'inbox.host_status.view_receipt',
    defaultMessage: 'View Receipt'
  },
  [INBOX_CTA_TITLES.RETRY_BOOKING]: {
    id: 'inbox.host_status.retry_booking',
    defaultMessage: 'Retry Booking'
  },
  [INBOX_CTA_TITLES.REVIEW_CUSTOM_OFFER]: {
    id: 'inbox.host_status.review_custom_offer',
    defaultMessage: 'Review and book'
  },
  [INBOX_CTA_TITLES.REVIEW_UPDATE_REQUEST]: {
    id: 'inbox.host_status.review_update_request',
    defaultMessage: 'Review Update Request'
  },
  [INBOX_CTA_TITLES.RETRY_PAYMENT]: {
    id: 'inbox.guest_status.retry_payment',
    defaultMessage: 'Retry payment'
  },
  [INBOX_CTA_TITLES.MANAGE_PAYMENTS]: {
    id: 'inbox.guest_status.manage_payments',
    defaultMessage: 'Manage payments'
  },
  [INBOX_CTA_TITLES.RETRY_UPDATE]: {
    id: 'inbox.host_status.retry_update',
    defaultMessage: 'Retry Update'
  },
  [INBOX_CTA_TITLES.WITHDRAW_UPDATE]: {
    id: 'inbox.host_status.withdraw_update',
    defaultMessage: 'Withdraw Update'
  },
  [INBOX_CTA_TITLES.CREATE_CUSTOM_OFFER]: {
    id: 'inbox.host_status.create_custom_offer',
    defaultMessage: 'Invite to book'
  },
  [INBOX_CTA_TITLES.CREATE_OFFER]: {
    id: 'inbox.host_status.create_custom_offer_text',
    defaultMessage: 'Create offer'
  },
  [INBOX_CTA_TITLES.REVIEW_BOOKING_REQUEST]: {
    id: 'inbox.host_status.review_booking_request',
    defaultMessage: 'Review booking request'
  },
  [INBOX_CTA_TITLES.ADD_PAYOUT_INFO]: {
    id: 'inbox.host_status.add_payout_info',
    defaultMessage: 'Add Payout Info'
  },
  [INBOX_CTA_TITLES.OFFER_CUSTOM_PRICE]: {
    id: 'inbox.host_status.offer_custom_price',
    defaultMessage: 'Send new offer'
  },
  [INBOX_CTA_TITLES.WITHDRAW_OFFER]: {
    id: 'inbox.host_status.withdraw_offer',
    defaultMessage: 'Withdraw offer'
  },
  [INBOX_CTA_TITLES.EDIT_OFFER]: {
    id: 'inbox.host_status.edit_offer',
    defaultMessage: 'Edit offer'
  },
  [INBOX_CTA_TITLES.UPDATE_INVITE]: {
    id: 'inbox.host_status.update_invite',
    defaultMessage: 'Update invite'
  },
  [INBOX_CTA_TITLES.AUTHORIZE_PAYMENT]: {
    id: 'inbox.guest_status.authorize_payment',
    defaultMessage: 'Authorize Payment'
  },
  [INBOX_CTA_TITLES.VIEW_BOOKING_DETAILS]: {
    id: 'inbox.guest_status.view_booking_details',
    defaultMessage: 'View Booking Details'
  }
});
